import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../../shared/utils/helpers';

const mutation = graphql`
  mutation CreateCategoryMutation($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      newCategory {
        id
      }
    }
  }
`;

const CreateCategoryMutation = (id, name, callback) => {
  const config = {
    mutation,
    variables: { input: { id, name } },
    onCompleted: (response, errors) => {
      callback(response.createCategory, errors);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default CreateCategoryMutation;
